// CRITICAL: Yandex.Metrika lazy-loaded — script инжектится в DOM ТОЛЬКО после consent.
// Если включить в index.html — куки ставятся ДО consent → CNIL fine риск.

const YM_ID = import.meta.env.VITE_YANDEX_METRIKA_ID as string | undefined;

let loaded = false;

export function loadYandexMetrika(): void {
  if (loaded) return;
  if (!YM_ID) {
    // eslint-disable-next-line no-console
    console.info('[ym] VITE_YANDEX_METRIKA_ID not set — Metrika skipped');
    return;
  }
  loaded = true;

  // Стандартный snippet from yandex.ru/metrika
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (function (m: any, e: Document, t: string, r: string, i: string) {
    m[i] = m[i] || function (...args: unknown[]) {
      (m[i].a = m[i].a || []).push(args);
    };
    m[i].l = Number(new Date());
    const k = e.createElement(t) as HTMLScriptElement;
    const a = e.getElementsByTagName(t)[0];
    k.async = true;
    k.src = r;
    if (a && a.parentNode) {
      a.parentNode.insertBefore(k, a);
    } else {
      (e.head || e.documentElement).appendChild(k);
    }
  })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).ym(YM_ID, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: false,
  });
}

export function isMetrikaLoaded(): boolean {
  return loaded;
}
